
type Order = 'asc' | 'desc';

function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
    if (a && !b) {
        return -1;
    }
    if (!a && b) {
        return 1;
    }
    if (!a && !b) {
        return 0;
    }
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator<Key extends keyof any>(
    order: Order,
    orderBy: Key,
): (a: { [key in Key]?: number | string | boolean | Date | undefined | null }, b: { [key in Key]?: number | string | boolean | Date | undefined | null }) => number {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function genericSort<T>(array: T[], comparator: (a: T, b: T) => number) {
    const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

interface IRiderLike {
    lapCount: number;
    bestTime: string;
}

function isZeroRider(rider: IRiderLike): boolean {
    return rider.lapCount === 0 || rider.bestTime === '00:00';
}

function getRiderComparator<Key extends keyof any>(
    order: Order,
    orderBy: Key,
): (a: IRiderLike & { [key in Key]?: number | string | boolean | Date | undefined | null },
    b: IRiderLike & { [key in Key]?: number | string | boolean | Date | undefined | null }) => number {
    const baseComparator = getComparator(order, orderBy);
    return (a, b) => {
        const aIsZero = isZeroRider(a);
        const bIsZero = isZeroRider(b);
        if (aIsZero && !bIsZero) return 1;
        if (!aIsZero && bIsZero) return -1;
        return baseComparator(a, b);
    };
}

export { genericSort, getComparator, getRiderComparator, isZeroRider };